import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getAllUsers } from '@api';
import { updateUserReferences } from '../_idMap/actions';

export const coreUsersAllGetAsyncSlice = createGetAsyncSlice({
	httpSagaOptions: {
		successDataActionCreators: [
			(response) =>
				updateUserReferences(
					response.results.map((user) => ({
						email: user.email,
						firstName: user.firstName,
						fullName: user.fullName,
						isLocked: user.isLocked,
						isReadOnly: user.isReadOnly,
						lastName: user.lastName,
						userId: user.id
					}))
				)
		]
	},
	name: 'CoreUsersAll',
	receive: true,
	request: 'optional',
	requestHandler: getAllUsers,
	retainDataOnRequest: true
});
